import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import flow from 'lodash/flow';
import withEmbedFavoriteCheck from 'src/common/decorators/withEmbedFavoriteCheck';
import icons from 'src/common/styles/icons.module.scss';
import PillButton from '../shared/button/PillButton';
import Text from '../Text';
import { FAVORITE, UNFAVORITE } from '../../constants/localizations/profile';

const HEART_ICON_STATE_FULL = 'icon-heart-full';
const HEART_ICON_STATE_EMPTY = 'icon-heart-empty';

class FavoriteButton extends Component {
  static propTypes = {
    isFollowing: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    handleFavoriteToggle: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      buttonLabel: FAVORITE,
      heartState: props.isFollowing
        ? HEART_ICON_STATE_FULL
        : HEART_ICON_STATE_EMPTY,
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFollowing !== this.props.isFollowing) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        buttonLabel: FAVORITE,
        heartState: this.props.isFollowing
          ? HEART_ICON_STATE_FULL
          : HEART_ICON_STATE_EMPTY,
      });
    }
  }

  onMouseEnter() {
    const { isFollowing, isMobile } = this.props;

    if (isMobile) return false;
    if (isFollowing) {
      this.setState({
        buttonLabel: UNFAVORITE,
        heartState: HEART_ICON_STATE_EMPTY,
      });
    } else {
      this.setState({
        buttonLabel: FAVORITE,
        heartState: HEART_ICON_STATE_FULL,
      });
    }
    return true;
  }

  onMouseLeave() {
    const { isFollowing, isMobile } = this.props;

    if (isMobile) return false;
    if (isFollowing) {
      this.setState({
        buttonLabel: FAVORITE,
        heartState: HEART_ICON_STATE_FULL,
      });
    } else {
      this.setState({
        buttonLabel: FAVORITE,
        heartState: HEART_ICON_STATE_EMPTY,
      });
    }
    return true;
  }

  render() {
    const { isFollowing, handleFavoriteToggle, className } = this.props;
    return (
      <PillButton
        id="favoriteButton"
        dataTestId="profileFavorite"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={() => handleFavoriteToggle(isFollowing)}
        className={className}
        icon={<i className={icons[this.state.heartState]} />}
        label={<Text name={this.state.buttonLabel} />}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { app } = state;
  return {
    isMobile: app.isMobile,
  };
};

export default flow(
  connect(mapStateToProps),
  withEmbedFavoriteCheck,
)(FavoriteButton);
